import React, { useState } from "react";

import JSZip from "jszip";

import { default as PhotoViewer } from "react-viewer";
import { ImageDecorator } from "react-viewer/lib/ViewerProps";

import "./viewer.css";
import "react-viewer/dist/index.css";
import "./dark-theme.css";

export default function Viewer() {
  const [visible, setVisible] = useState<boolean>(false);
  const [images, setImages] = useState<ImageDecorator[]>();
  const [error, setError] = useState<Error>();
  const [status, setStatus] = useState("");
  const [filename, setFilename] = useState("");
  const [loading, setLoading] = useState(false);

  const fileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (!files)
      return setError(new Error("No file selected. Please select a file."));
    const file = files[0];
    const zip = new JSZip();
    try {
      setLoading(true);
      setStatus("Loading file...");
      setFilename(file.name);
      const unzip = await zip.loadAsync(file);
      const imagePromises: Promise<string>[] = [];
      Object.keys(unzip.files).forEach((filename) => {
        const imageFile = unzip.files[filename];
        if (!imageFile.dir && imageFile.name.toLowerCase().endsWith(".jpg")) {
          imagePromises.push(zip.file(filename).async("base64"));
        }
      });
      setStatus("Loading images...");
      const base64s = await Promise.all(imagePromises);
      const images = base64s.map((base64) => ({
        src: `data:image/jpeg;base64,${base64}`,
      }));
      setStatus("Images loaded.");
      setLoading(false);
      setImages(images);
      setVisible(true);
    } catch (error) {
      setError(error);
    }
  };

  if (error) return <span>There was an error: {error}</span>;

  return (
    <>
      <h1 className="header">Comic Reader</h1>
      <div className="container">
        <input
          type="file"
          id="input"
          onChange={fileUpload}
          accept=".zip,.cbz"
          className="input"
        />
        <label htmlFor="input" className="input-label">
          Upload a comic book (.cbz|.zip)
        </label>
        {filename && <p>File: {filename}</p>}
        {loading && <div className="loader" />}
        <p>{status}</p>
        <p>
          A project by{" "}
          <a
            href="https://github.com/lioialessandro"
            target="_blank"
            rel="noopener noreferrer"
          >
            Lioi Alessandro
          </a>
        </p>
        <a
          href="https://paypal.me/lioialessandro/5"
          target="_blank"
          rel="noopener noreferrer"
        >
          <p>Support me!</p>
        </a>
        <PhotoViewer
          visible={visible}
          images={images}
          onClose={() => setVisible(false)}
          rotatable={false}
          downloadable={false}
          scalable={false}
          attribute={false}
        />
      </div>
    </>
  );
}
